<template>
  <div>
    <!-- <infos :type="8" v-show="!isFinished" @nextButton="submit" @goBack="back"></infos> -->
    <div class="panel-group last-panel" id="book-flight-resume">
      <div class="panel">
        <div class="col-md-12">
          <div v-show="isFinished">
            <p><i class="fa fa-check"></i> Incrição realizada com sucesso.</p>
            <small>Segue o resumo de suas escolhas.</small>
            <small>Qualquer divergência, solicitação ou dúvida, entrar em contato
              com a Origami Eventos e Turismo.</small>
          </div>
          <div class="col-md-12" v-show="!isFinished && !showEmailMessage">
            <p>
              Pronto! Agora é só conferir todas as informações e concluir a
              inscrição. Caso queira alterar alguma informação, basta clicar em
              voltar.
            </p>
          </div>
          <div class="col-md-12" v-show="showEmailMessage">
            <p>
              Inscrição concluída com sucesso.<br />Abaixo, segue a confirmação
              e a escolha dos voos. Fique atento aos próximos Comunicados da
              Franqueadora.
            </p>
          </div>
          <br /><br />
          <div class="book-flight" id="book-flight">
            <div class="book-flight__panel" v-for="(issue, j) in selectedFlight" :key="issue.passanger.id">
              <div v-if="
                  selectedFlight[j] &&
                  selectedFlight[j].flight &&
                  selectedFlight[j].flight.company
                ">
                <div class="book-flight__panel__heading">
                  <div class="book-flight__panel__heading--selection">
                    <label :for="'selectFlight' + selectedFlight[j].flight.id">
                      Voo selecionado:&nbsp;
                      {{
                      selectedFlight[j].guest
                      ? selectedFlight[j].passanger.guest
                      : selectedFlight[j].passanger.badgeName
                      }}&nbsp; <i class="fa fa-plane"></i>&nbsp;&nbsp;Opção
                      {{ selectedFlight[j].flight.group_number }} -
                      <strong>{{ selectedFlight[j].flight.city }}</strong> -
                      {{ selectedFlight[j].flight.company }}
                    </label>
                  </div>
                  <div v-if="selectedFlight[j].flight.attachment_binary">
                    <img v-bind:src="
                        'data:image/jpeg;base64,' +
                        selectedFlight[j].flight.attachment_binary
                      " width="100%" />
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="book-flight__panel__heading" v-if="Boolean(selectedFlight[j].flight)">
                  <div class="book-flight__panel__heading--selection">
                    <label :for="'selectFlight' + selectedFlight[j].flight.id">
                      Voo selecionado:&nbsp;{{
                      selectedFlight[j].guest
                      ? selectedFlight[j].passanger.name
                      : selectedFlight[j].passanger.badgeName
                      }}
                      <i class="fa fa-plane"></i>&nbsp;&nbsp;Opção
                      {{ selectedFlight[j].flight.group_number }}
                    </label>
                  </div>
                  <div class="book-flight__panel__heading--info">
                    <div class="book-flight__panel__heading--info--1">
                      <p>Obs: A Origami entrará em contato com você.</p>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="book-flight__panel__heading" v-if="Boolean(selectedFlight[j].flight)">
                <div class="book-flight__panel__heading--selection">
                  <label :for="'selectFlight2' + selectedFlight[j].flight.id">
                    Itens selecionados relacionados ao voo
                  </label>
                </div>
                <div class="book-flight__panel__heading--info">
                  <div class="book-flight__panel__heading--info--1">
                    <small v-if="changeDate">
                      <i class="fa fa-long-arrow-right"></i> Deseja realizar
                      alteração de data de retorno e/ou adicionar trechos nesse
                      voo mediante disponibilidade e custo adicional.
                      <br />
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="book-flight" id="book-flight">
            <div class="book-flight__panel">
              <div class="book-flight__panel__heading">
                <div class="guests-extras" style="text-align: center">
                  <label>{{ user.participant.badgeName }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(guest, i) in account.issuance" :key="i">
            <div class="book-flight" id="book-flight">
              <div class="book-flight__panel">
                <div class="book-flight__panel__heading">
                  <div class="guests-extras" style="text-align: center">
                    <label>
                      {{ guest.guest }}, {{ guest.age }}
                      {{ guest.age > 1 ? " anos" : " ano" }},
                      {{ guest.formattedKinship }}. <span v-if="guest.isExtra" class="badge">Extra</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div class="col-md-12" v-show="!isFinished">
            <p>
              <strong>Importante:</strong> Somente após clicar em <b>FINALIZAR</b>, sua inscrição e opção de voos
              estarão confirmadas. E não será possível voltar e fazer qualquer tipo de alteração.
            </p>
            <button @click="back()" v-show="!isFinished && !showEmailMessage">
              Voltar
            </button>
            <button @click="submit()" v-show="!isFinished && !showEmailMessage">
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="action-buttons" v-if="isFinished">
      <button style="width: 100%;" @click="atendimento"><i class="fa fa-icon fa-whatsapp"></i>&nbsp;Atendimento Whatsapp
        Origami Turismo</button>
      <button @click="finish" style="width: 50%;"><i class="fa fa-icon fa-sign-out"></i>&nbsp;Log Out</button>
      <button @click="print" style="width: 49%;"><i class="fa fa-icon fa-print"></i>&nbsp;Imprimir</button>
    </div>
  </div>
</template>

<script>
import { mixin } from "../../mixin.js";
import Infos from "../Infos.vue";
import CustomButtom from "../shared/CustomButton.vue";
export default {
  components: {
    Infos,
    "custom-button": CustomButtom,
  },
  mixins: [mixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
    account: {
      type: Object,
      required: true,
    },
    flights: {},
    selectedFlight: {
      type: Array,
      required: true,
    },
    changeDate: {
      type: Boolean,
      required: true,
    },
    isFinished: {
      type: Boolean,
      required: true,
    },
    showEmailMessage: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    submit: function () {
      this.$emit("handleSubmit", "Conclusão", true);
      this.scrollOnTop();
    },
    back: function () {
      this.$emit("changeTab", "Adicionais");
      this.scrollOnTop();
    },
    finish: function () {
      this.$emit("handleLogout");
      this.scrollOnTop();
    },
    print: function () {
      window.print();
    },
    atendimento: function () {
      window.open("https://wa.me/5521988190007", '_blank');
    },
    flightDetail: function (index) {
      this.selectedFlight[index].display = !this.selectedFlight[index].display;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/tabs/Finish.vue